import { useMutation } from '@tanstack/react-query'

import { uploadPaymentRequestEvidenceImage } from '@src/api'
import { DefaultApiUploadPaymentRequestEvidenceImageRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useUploadPaymentRequestEvidenceImage = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiUploadPaymentRequestEvidenceImageRequest) =>
      uploadPaymentRequestEvidenceImage(axiosInstance, params),
  })
}
